(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-gallery-gifts"] && !Shopify.designMode) return;
  try {
    

const slider = document.querySelector('.items');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});





var button = document.getElementById('righty');
button.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'right',15,300,50);
};

var back = document.getElementById('lefty');
back.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'left',15,300,50);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-other"] && !Shopify.designMode) return;
  try {
    

const slider = document.querySelector('.items');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});





var button = document.getElementById('righty');
button.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'right',15,300,50);
};

var back = document.getElementById('lefty');
back.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'left',15,300,50);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-street-photography"] && !Shopify.designMode) return;
  try {
    

const slider = document.querySelector('.items');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});





var button = document.getElementById('righty');
button.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'right',15,300,50);
};

var back = document.getElementById('lefty');
back.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'left',15,300,50);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-new"] && !Shopify.designMode) return;
  try {
    

const slider = document.querySelector('.items');
let isDown = false;
let startX;
let scrollLeft;

slider.addEventListener('mousedown', (e) => {
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
});
slider.addEventListener('mouseleave', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mouseup', () => {
  isDown = false;
  slider.classList.remove('active');
});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
  console.log(walk);
});





var button = document.getElementById('righty');
button.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'right',15,360,50);
};

var back = document.getElementById('lefty');
back.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container,'left',15,360,50);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}

AOS.init();

window.addEventListener('load', function() {
  AOS.refresh();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-carousel-homepage"] && !Shopify.designMode) return;
  try {
    
  const slider = document.querySelector('.items');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    console.log(walk);
  });

  var button = document.getElementById('righty');
  button.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container, 'right', 15, 360, 50);
  };

  var back = document.getElementById('lefty');
  back.onclick = function () {
    var container = document.getElementById('items');
    sideScroll(container, 'left', 15, 360, 50);
  };

  function sideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  AOS.init();

  window.addEventListener('load', function () {
    AOS.refresh();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-carousel-new"]) return;
  try {
    

var button = document.getElementById('righty');
button.onclick = function () {
    var container = document.getElementById('my_container_id');
    sideScroll(container,'right',15,300,50);
};

var back = document.getElementById('lefty');
back.onclick = function () {
    var container = document.getElementById('my_container_id');
    sideScroll(container,'left',15,300,50);
};

function sideScroll(element,direction,speed,distance,step){
    scrollAmount = 0;
    var slideTimer = setInterval(function(){
        if(direction == 'left'){
            element.scrollLeft -= step;
        } else {
            element.scrollLeft += step;
        }
        scrollAmount += step;
        if(scrollAmount >= distance){
            window.clearInterval(slideTimer);
        }
    }, speed);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["framed-carousel-section"]) return;
  try {
    
  var button = document.getElementById('righty');
  button.onclick = function () {
    var container = document.getElementById('my_container_id');
    sideScroll(container, 'right', 15, 300, 50);
  };

  var back = document.getElementById('lefty');
  back.onclick = function () {
    var container = document.getElementById('my_container_id');
    sideScroll(container, 'left', 15, 300, 50);
  };

  function sideScroll(element, direction, speed, distance, step) {
    scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  } catch(e) { console.error(e); }
})();
})();
